import { render, staticRenderFns } from "./RelatorioListagem.vue?vue&type=template&id=0926163b"
import script from "./RelatorioListagem.vue?vue&type=script&lang=ts"
export * from "./RelatorioListagem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports